import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "flex items-center border-gray-700 border-b pt-3 px-4 pb-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "flex-1" }, [
    /*#__PURE__*/_createVNode("span", { class: "font-medium" }, "Live swap rates")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "w-20 flex justify-center" }, [
    /*#__PURE__*/_createVNode("img", {
      src: "https://assets.coingecko.com/coins/images/15223/small/logo_200x200.png",
      width: "32"
    })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "w-20 flex justify-center" }, [
    /*#__PURE__*/_createVNode("img", {
      src: "https://storageapi.fleek.co/beethovenxfi-team-bucket/SPIRIT.png",
      width: "32"
    })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "w-20 flex justify-center" }, [
    /*#__PURE__*/_createVNode("img", {
      src: "https://beethoven-assets.s3.eu-central-1.amazonaws.com/beets-icon-large.png",
      width: "32"
    })
  ])
], -1)
const _hoisted_2 = { class: "flex items-center flex-1" }
const _hoisted_3 = { class: "ml-2 font-medium w-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalAsset = _resolveComponent("BalAsset")
  const _component_BalIcon = _resolveComponent("BalIcon")
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")
  const _component_BalCard = _resolveComponent("BalCard")

  return (_openBlock(), _createBlock(_component_BalCard, {
    shadow: "lg",
    class: "mt-8",
    noPad: ""
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, idx) => {
        return (_openBlock(), _createBlock("div", {
          key: item.id,
          class: [
        'flex items-center border-gray-700 pt-2 px-3',
        idx === _ctx.items.length - 1 ? 'pb-4' : 'pb-2 border-b'
      ]
        }, [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_BalAsset, {
              address: item.tokenIn,
              size: 24
            }, null, 8, ["address"]),
            _createVNode("div", _hoisted_3, _toDisplayString(item.amountInNumberFormatted), 1),
            _createVNode(_component_BalIcon, {
              name: "arrow-right",
              size: "sm",
              class: "ml-1 mr-2 flex items-center"
            }),
            _createVNode(_component_BalAsset, {
              address: item.tokenOut,
              size: 24
            }, null, 8, ["address"])
          ]),
          _createVNode("div", {
            class: [
          'w-20 flex justify-center',
          _ctx.spooky[idx] > _ctx.beets[idx] && _ctx.spooky[idx] > _ctx.spirit[idx]
            ? 'text-green-500'
            : ''
        ]
          }, [
            _createTextVNode(_toDisplayString(_ctx.spooky[idx] ? _ctx.numeral(_ctx.spooky[idx]).format(item.amountOutFormat) : '') + " ", 1),
            (!_ctx.spooky[idx])
              ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                  key: 0,
                  class: "h-4 w-12 mx-auto",
                  white: ""
                }))
              : _createCommentVNode("", true)
          ], 2),
          _createVNode("div", {
            class: [
          'w-20 flex justify-center',
          _ctx.spirit[idx] > _ctx.spooky[idx] && _ctx.spirit[idx] > _ctx.beets[idx]
            ? 'text-green-500'
            : ''
        ]
          }, [
            _createTextVNode(_toDisplayString(_ctx.spirit[idx] ? _ctx.numeral(_ctx.spirit[idx]).format(item.amountOutFormat) : '') + " ", 1),
            (!_ctx.spirit[idx])
              ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                  key: 0,
                  class: "h-4 w-12 mx-auto",
                  white: ""
                }))
              : _createCommentVNode("", true)
          ], 2),
          _createVNode("div", {
            class: [
          'w-20 flex justify-center',
          _ctx.beets[idx] > _ctx.spooky[idx] && _ctx.beets[idx] > _ctx.spirit[idx]
            ? 'text-green-500'
            : ''
        ]
          }, [
            _createTextVNode(_toDisplayString(_ctx.beets[idx] ? _ctx.numeral(_ctx.beets[idx]).format(item.amountOutFormat) : '') + " ", 1),
            (!_ctx.beets[idx])
              ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                  key: 0,
                  class: "h-4 w-12 mx-auto",
                  white: ""
                }))
              : _createCommentVNode("", true)
          ], 2)
        ], 2))
      }), 128))
    ]),
    _: 1
  }))
}